import api from "./api";

export type GroupMember = {
  id: string;
  group_id: string;
  athlete_id: string;
  added_at: string;
  athlete: {
    id: string;
    full_name: string | null;
    email: string;
    athlete_profiles?: {
      id: string;
      team_id?: string;
    };
  };
};

export type Group = {
  id: string;
  team_id: string;
  name: string;
  description: string | null;
  created_by: string;
  created_at: string;
  updated_at: string;
  creator?: {
    id: string;
    full_name: string | null;
    email: string;
  };
  team?: {
    id: string;
    name: string;
    age_group: string | null;
  };
  members?: GroupMember[];
  _count?: {
    members: number;
  };
};

/**
 * Get all groups for a team
 */
export async function getTeamGroups(teamId: string) {
  const { data } = await api.get<Group[]>(`/groups/team/${teamId}`);
  return data;
}

/**
 * Get a specific group by ID
 */
export async function getGroupById(groupId: string) {
  const { data } = await api.get<Group>(`/groups/${groupId}`);
  return data;
}

/**
 * Create a new group
 */
export async function createGroup(payload: {
  team_id: string;
  name: string;
  description?: string;
}) {
  const { data } = await api.post<Group>("/groups", payload);
  return data;
}

/**
 * Update a group
 */
export async function updateGroup(
  groupId: string,
  payload: {
    name?: string;
    description?: string;
  }
) {
  const { data } = await api.patch<Group>(`/groups/${groupId}`, payload);
  return data;
}

/**
 * Delete a group
 */
export async function deleteGroup(groupId: string) {
  const { data } = await api.delete<{ message: string }>(`/groups/${groupId}`);
  return data;
}

/**
 * Add athlete to group
 */
export async function addGroupMember(groupId: string, athleteId: string) {
  const { data } = await api.post<GroupMember>(`/groups/${groupId}/members`, {
    athlete_id: athleteId,
  });
  return data;
}

/**
 * Remove athlete from group
 */
export async function removeGroupMember(groupId: string, athleteId: string) {
  const { data } = await api.delete<{ message: string }>(
    `/groups/${groupId}/members/${athleteId}`
  );
  return data;
}
